module.exports = __webpack_public_path__ + "static/img/open-diamond.5537ddf0.png";